var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Envelope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5888 4.23462L2.58887 4.26509C2.42311 4.26542 2.26427 4.3316 2.1473 4.44904C2.03033 4.56649 1.9648 4.7256 1.96514 4.89136L1.98672 15.5163C1.98739 15.8479 2.11974 16.1655 2.35463 16.3995C2.58953 16.6334 2.90774 16.7645 3.23926 16.7638L16.9892 16.7359C17.3207 16.7352 17.6384 16.6028 17.8724 16.368C18.1063 16.1331 18.2374 15.8148 18.2367 15.4833L18.2151 4.85835C18.2148 4.69259 18.1486 4.53375 18.0311 4.41678C17.9137 4.29981 17.7546 4.23428 17.5888 4.23462ZM10.1024 10.9022L4.19843 5.51182L15.9843 5.48788L10.1024 10.9022ZM7.81327 10.5045L3.2351 14.7177L3.21802 6.30991L7.81327 10.5045ZM8.73999 11.3503L9.67924 12.2116C9.79476 12.3173 9.94571 12.3757 10.1022 12.3754C10.2588 12.375 10.4095 12.316 10.5246 12.2099L11.4603 11.3447L16 15.4879L4.21875 15.5118L8.73999 11.3503ZM12.3898 10.4952L16.968 6.28119L16.9851 14.6906L12.3898 10.4952Z",
    fill: "#98A2B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a1d496eb66a1621940eb2208e642efe4.svg";
export { ForwardRef as ReactComponent };